import request from './request'
import ticket from './ticket'
import system from './system'

/**
 * @typedef {Object} RequestMessageType
 * @property {string} key                               key of the message type
 * @property {string} value                             value of the message type
 * @property {boolean} default                          whether this type is the default selection
 * @property {boolean} priorSelection                   whether this type needs a prior selection
 *
 * @property {IconType} icon                         icon for the type
 * @property {IconType.color} color                  color for the type
 * @property {IconType.background} backgroundColor   background color for the type
 *
 * @property {string} labelText                         label text for the type
 * @property {string} backgroundText                    background text for the type
 * @property {number[]} status                          statuses where to display this type
 * @property {Object<number, number>} newStatus         how the request status should be changed by
 *                                                      sending a message of this type
 */

/**
 * @typedef {Object} TicketMessageType
 * @property {string} key                               key of the message type
 * @property {string} value                             value of the message type
 * @property {boolean} default                          whether this type is the default selection
 * @property {boolean} priorSelection                   whether this type needs a prior selection
 *
 * @property {IconType} icon                         icon for the type
 * @property {IconType.color} color                  color for the type
 * @property {IconType.background} backgroundColor   background color for the type
 *
 * @property {string} labelText                         label text for the type
 * @property {string} backgroundText                    background text for the type
 * @property {number[]} status                          statuses where to display this type
 * @property {number} newStatus                         how the ticket status should be changed by
 *                                                      sending a message of this type
 * @property {number} newStatusReason                   how the ticket status reason should be
 *                                                      changed by sending a message of this type
 */

/**
 * @typedef {Object} SystemMessageType
 * @property {string} key                               key of the message type
 * @property {string} value                             value of the message type
 * @property {boolean} default                          whether this type is the default selection
 * @property {boolean} priorSelection                   whether this type needs a prior selection
 *
 * @property {IconType} icon                         icon for the type
 * @property {IconType.color} color                  color for the type
 * @property {IconType.background} backgroundColor   background color for the type
 */

/**
 * @type {(RequestMessageType|TicketMessageType|SystemMessageType)[]} AllMessageTypes
 */
const all = [
  ...request,
  ...ticket,
  ...system,
]

const messageTypes = {
  request,
  ticket,
  system,
  all,
}

export {
  messageTypes as default,
  request,
  ticket,
  system,
  all,
}
